var _desc, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    viewBox: "424.72 437.42 230.57 205.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "de5fc6bb-884d-4dc8-82fc-8803bff2e726"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255, 255, 255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-115.27, -115.27)",
    d: "M 189.367 182.416 L 168.904 182.577 C 169.917 169.926 173.846 149.982 186.768 126.453 C 201.489 99.649 202.358 72.837 189.214 50.956 C 175.036 27.353 146.047 12.378 115.413 12.719000000000001 L 115.12599999999999 12.719000000000001 C 84.48299999999999 12.360000000000001 55.50299999999999 27.353 41.32499999999999 50.956 C 28.18099999999999 72.837 29.050999999999988 99.649 43.77099999999999 126.453 C 56.75999999999999 150.106 60.69099999999999 169.948 61.67899999999999 182.577 L 41.17199999999998 182.416 L 31.774999999999984 162.061 L 0 176.73 L 18.701 217.23999999999998 L 93.46100000000001 217.82899999999998 L 96.025 203.24299999999997 C 96.32100000000001 201.56199999999995 102.936 161.47499999999997 74.45 109.60499999999996 C 65.727 93.72099999999996 64.677 80.05199999999996 71.33 68.97699999999996 C 78.991 56.22199999999996 96.874 47.51499999999996 114.785 47.715999999999966 L 114.901 47.71799999999997 L 115.755 47.715999999999966 C 133.702 47.502999999999965 151.54899999999998 56.221999999999966 159.20999999999998 68.97699999999996 C 165.86299999999997 80.05199999999996 164.813 93.72099999999996 156.08999999999997 109.60499999999996 C 127.60399999999997 161.47499999999997 134.21899999999997 201.56199999999995 134.515 203.24299999999997 L 137.07899999999998 217.82899999999998 L 211.839 217.23999999999998 L 230.54 176.73 L 198.76299999999998 162.06 L 189.367 182.416 z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.22fd57c304b910bc104b96d94519a8fc.svg";
export { ForwardRef as ReactComponent };